export const OTP_ID_FIELD_NAME = "otpId";
export const OTP_CODE_FIELD_NAME = "otpCode";
